import { z } from 'zod'
import { corporateAccountInfoSchema } from '~library/models'
import { managerInfoSchema } from './manager-info'

export const administratorInformationSchema = z.object({
  /** 管理者資訊 */
  managerInfo: managerInfoSchema.nullable(),
  /** 企業帳號資訊 */
  mainAccountInfo: corporateAccountInfoSchema.nullable(),
  /** 子帳號列表 */
  subAccountList: z.array(corporateAccountInfoSchema)
})

export interface AdministratorInformation
  extends z.infer<typeof administratorInformationSchema> {}
